module.exports = __webpack_public_path__ + "img/20190515144919.d5d0dd94.jpg";